import React from 'react';

const Header = ({onClick}) => {
    return (
        <div className="chat-header">
            <button onClick={onClick}> show </button>
            <button> close chat </button>
        </div>
    )
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/chat/Header.js